import { Injectable, ElementRef } from '@angular/core';
import { HttpService } from "./http.service";
import { debug } from 'util';
import { UserDataStoreService } from './user-data-store.service';
import { MerchantReportDTViewModel } from '../models/merchant-report-dt-view-model';
import { ClientReportDTViewModel } from '../models/client-report-dt-view-model';
import { promise } from 'protractor';
import { CreateResult } from '../models/create-result';
import { TerminalReportDTViewModel } from '../models/terminal-report-dt-view-model';
import { MerchantGroupReportDTViewModel } from '../models/merchant-group-report-dt-view-model';
import { TutukaReportDTViewModel } from '../models/tutuka-report-dt-view-model';
import { BankTransactionData } from '../models/bank-transaction-data-view-model';
import { ParticipantViewModel } from '../models/participant-view-model';
import { UserViewModel } from '../models/user-view-model';
import { MerchantReportUserLinkDTViewModel } from '../models/merchant-report-user-link-dt-view-model';
import { TerminalReportUserLinkDTViewModel } from '../models/terminal-report-user-link-dt-view-model';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ExcelJson } from '../models/Excel-Json-model';
import { ReportClientParticipantLink } from '../models/report-client-participant-link';
import { CreditBalanceViewModel } from '../models/credit-balance-view-model';
import { TerminalSignUpViewModel } from '../models/terminal-signup-view-model';
import { ReturnedTerminalsViewModel } from '../models/returned-terminals-view-model';
import { GenericReportViewModel } from '../models/generic-report-view-model';
import { GenericTransactionsViewModel } from '../models/generic-transactions-view-model';
import { DailyMerchantReportUserLinkViewModel } from '../models/daily-merchant-report-user-link-view-model';
import { ExceptionReportViewModel, ExceptionTransactionsViewModel, GiftCardTransactionsViewModel, ReconReportViewModel, ReconTransactionsViewModel} from "../models/recon-report-view-model";


const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ReportService {



  public count: number = 0;

  constructor(private _httpService: HttpService, private _userDataStore: UserDataStoreService) {
  }


  public async GetByUSSNumber(merchantNumber: string): Promise<MerchantReportDTViewModel> {
    const httpResult = await this._httpService.apiGet<MerchantReportDTViewModel>(`report/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetReturnedTerminalCustomers(): Promise<string[]> {
    const httpResult = await this._httpService.apiGet<string[]>(`report/GetReturnedTerminalCustomers`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetReturnedTerminalsReport(endpoint: string): Promise<ReturnedTerminalsViewModel[]> {
    const httpResult = await this._httpService.apiGet<ReturnedTerminalsViewModel[]>(endpoint);
    debugger;
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetTerminalsByUSSNumber(merchantNumber: string, merchantId: number): Promise<TerminalReportDTViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalReportDTViewModel[]>(`report/terminals/${merchantNumber}/${merchantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async linkTerminal(merchantNumber: string, terminalId: string): Promise<CreateResult> {
    const httpResult = await this._httpService.apiGet<CreateResult>(`report/linkTerminals/${merchantNumber}/${terminalId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async registerMerchant(merchant: string, shopName: string): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`report/registerMerchant/${merchant}/${shopName}`);
    debugger;
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async SyncMerchants(participantId: number): Promise<CreateResult> {
    const httpResult = await this._httpService.apiGet<CreateResult>(`report/syncMerchant/${participantId}`);
    debugger;
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async removeTerminalLink(terminalId: string, merchantNumber: string): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`report/removeTerminalLink/${terminalId}/${merchantNumber}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetAllTerminalsByClient(id: string): Promise<TerminalReportDTViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalReportDTViewModel[]>(`report/terminalsByClient/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetAllMerchants(): Promise<MerchantReportDTViewModel[]> {

    const httpResult = await this._httpService.apiGet<MerchantReportDTViewModel[]>(`report/Search`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }



  public async GetAllMerchantsByParticipants(id: string): Promise<MerchantReportDTViewModel[]> {

    const httpResult = await this._httpService.apiGet<MerchantReportDTViewModel[]>(`report/allByParticipant/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];

  }

  public async LinkUserToMerchant(merchantId: string, userId: string): Promise<CreateResult> {
    const httpResult = await this._httpService.apiGet<CreateResult>(`report/linkMerchantToUser/${merchantId}/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async deleteUserLinkToMerchant(merchantId: string, userId: string): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`report/deleteMerchantToUser/${merchantId}/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async Bankreport_csv1(): Promise<any> {
    const httpResult = await this._httpService.apiPost<any>(`report/ExportBankReportCSV`, "test");
    const data = httpResult.body;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = ('TerminalConfigAuditTrail_.csv');
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  public async GetAllMerchantsReportsUserLinkByUser(userId: string): Promise<MerchantReportUserLinkDTViewModel[]> {
    const httpResult = await this._httpService.apiGet<MerchantReportUserLinkDTViewModel[]>(`report/MerchantReportUserLink/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetDailyMerchantsByUser(userId: string): Promise<DailyMerchantReportUserLinkViewModel[]> {
    const httpResult = await this._httpService.apiGet<DailyMerchantReportUserLinkViewModel[]>(`report/DailyReportUserLink/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetAllMerchantsLinksByUser(userId: string): Promise<MerchantReportUserLinkDTViewModel[]> {
    const httpResult = await this._httpService.apiGet<MerchantReportUserLinkDTViewModel[]>(`report/GetAllMerchantsLinksByUser/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetAllTerminalsReportsUserLinkByUser(merchantId: number, userId: string): Promise<TerminalReportUserLinkDTViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalReportUserLinkDTViewModel[]>(`report/TerminalReportUserLink/${merchantId}/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }


  public async GetAllTerminalsReportsLinkByUser(merchantId: number, userId: string): Promise<TerminalReportUserLinkDTViewModel[]> {
    const httpResult = await this._httpService.apiGet<TerminalReportUserLinkDTViewModel[]>(`report/TerminalReportUserLinks/${merchantId}/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetByUserId(userId: string): Promise<UserViewModel> {

    const httpResult = await this._httpService.apiGet<UserViewModel>(`report/GetByUser/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }

    return null;
  }

  public async GetClients(): Promise<ClientReportDTViewModel[]> {

    const httpResult = await this._httpService.apiGet<ClientReportDTViewModel[]>(`report/Clients`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetAllMerchantGroups(clientId: string): Promise<MerchantGroupReportDTViewModel[]> {

    const httpResult = await this._httpService.apiGet<MerchantGroupReportDTViewModel[]>(`report/MerchantGroups/${clientId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetBankReportData(startDate: Date, endDate: Date): Promise<BankTransactionData> {

    const httpResult = await this._httpService.apiGet<BankTransactionData>(`report/GetData/${startDate}/${endDate}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return;
  }

  public async GetBankReportDataByMerchant(startDate: Date, endDate: Date, merchant: string): Promise<BankTransactionData> {

    const httpResult = await this._httpService.apiGet<BankTransactionData>(`report/GetDataByMerchant/${startDate}/${endDate}/${merchant}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return;
  }

  public async GetTerminalSignUpReportcopy(customerId: number): Promise<TerminalSignUpViewModel[]> {
    var startDate = '2024-01-01';
    var endDate = '2025-01-01';
    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`report/GetTerminalSignUpReport/${startDate}/${endDate}/${customerId}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return;
  }

  public async GetTerminalSignUpReport(startDate: Date, endDate: Date, customerId: number): Promise<TerminalSignUpViewModel[]> {

    const httpResult = await this._httpService.apiGet<TerminalSignUpViewModel[]>(`report/GetTerminalSignUpReport/${startDate}/${endDate}/${customerId}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return;
  }

  public async GetReturnedDevicesReport(startDate: Date, endDate: Date, customer: string): Promise<ReturnedTerminalsViewModel[]> {

    const httpResult = await this._httpService.apiGet<ReturnedTerminalsViewModel[]>(`report/GetReturnedTerminalsReport/${startDate}/${endDate}/${customer}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return;
  }


  public async Create(merchants: MerchantReportDTViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`report/Create`, merchants);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async Update(merchants: MerchantReportDTViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPut<CreateResult>(`report/Update`, merchants);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetAllParticipants(): Promise<ParticipantViewModel[]> {
    const httpResult = await this._httpService.apiGet<ParticipantViewModel[]>(`report/participants`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetAllUsersByParticipant(participantId: string): Promise<UserViewModel[]> {
    const httpResult = await this._httpService.apiGet<UserViewModel[]>(`report/users/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];

  }

  public async GetClientParticipantLinks(): Promise<ReportClientParticipantLink[]> {
    const httpResult = await this._httpService.apiGet<ReportClientParticipantLink[]>(`report/ClientParticipantLink`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];

  }

  public async addClientParticipantLink(clientParticipantLink: ReportClientParticipantLink): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`report/addClientParticipantlink`, clientParticipantLink);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }
  public async removeClientParticipantLink(clientParticipantLink: ReportClientParticipantLink): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`report/removeClientParticipantlink`, clientParticipantLink);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }


  public exportTableElmToExcel(element: ElementRef, fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element.nativeElement);
    // generate workbook and add the worksheet
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, 'Sheet1');
    // save to file
    XLSX.writeFile(workbook, `${fileName}${EXCEL_EXTENSION}`);

  }

  public exportJsonToExcel(json: ExcelJson[], fileName: string): void {
    // inserting first blank row
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      json[0].data,
      this.getOptions(json[0])
    );

    for (let i = 1, length = json.length; i < length; i++) {
      // adding a dummy row for separation
      XLSX.utils.sheet_add_json(
        worksheet,
        [{}],
        this.getOptions(
          {
            data: [],
            skipHeader: true
          }, -2)
      );
      XLSX.utils.sheet_add_json(
        worksheet,
        json[i].data,
        this.getOptions(json[i], -1)
      );
    }
    const workbook: XLSX.WorkBook = { Sheets: { Sheet1: worksheet }, SheetNames: ['Sheet1'] };
    // save to file
    XLSX.writeFile(workbook, `${fileName}${EXCEL_EXTENSION}`);
  }

  private getOptions(json: ExcelJson, origin?: number): any {
    const options = {
      skipHeader: true,
      origin: -1,
      header: []
    };
    options.skipHeader = json.skipHeader ? json.skipHeader : false;
    if (!options.skipHeader && json.header && json.header.length) {
      options.header = json.header;
    }
    if (origin) {
      options.origin = origin ? origin : -1;
    }
    return options;
  }

  public async GetReconData(reconReport: GenericReportViewModel): Promise<ReconTransactionsViewModel[]> {
    const httpResult = await this._httpService.apiPost<ReconTransactionsViewModel[]>(`report/ReconReport/`, reconReport);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetGiftCardData(reconReport: GenericReportViewModel): Promise<GiftCardTransactionsViewModel[]> {
    const httpResult = await this._httpService.apiPost<GiftCardTransactionsViewModel[]>(`report/GiftCardReport/`, reconReport);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetGenericData(genericReport: GenericReportViewModel): Promise<GenericTransactionsViewModel[]> {
    const httpResult = await this._httpService.apiPost<GenericTransactionsViewModel[]>(`report/RawReport/`, genericReport);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetQrData(qrReport: GenericReportViewModel): Promise<GenericTransactionsViewModel[]> {
    const httpResult = await this._httpService.apiPost<GenericTransactionsViewModel[]>(`report/QrReport/`, qrReport);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetExceptionData(reconReport: GenericReportViewModel): Promise<GenericTransactionsViewModel[]> {
    const httpResult = await this._httpService.apiPost<GenericTransactionsViewModel[]>(`report/ExceptionReport/`, reconReport);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }
}
